import {Card as MuiCard, styled} from '@mui/material';

const Card = styled(MuiCard)(({theme}) => {
  return {
    backgroundColor: theme.palette.background.paper,
  }
})

export {Card};